export default class LandmanBillInfo {
    lmNo: number;
    billUnit: string;
    billRate: number;
    chgDate: Date;
    mgrNo: number;
    prevUnit?: string;
    prevRate?: number;
    tsdUser: string;
    effDate: Date;
    id: number;
}


// WEBPACK FOOTER //
// ./src/models/personnel/LandmanBillInfo.ts